import Repository from './trackerRepository'
/**
 * Group of methods and properties to run web request
 */
export default {
	/**
	 * Search for a tracker identified by a token
	 */
	setTracker: (token, isDemo) => {
		if (isDemo) {
			return Repository.mock().then(res => res)
		}
		Repository.setToken(token)
		return Repository.get('/info').then(res => res.data)
	},
	/**
	 * Mock API datas
	 */
	getTrackerMock: () => {
		return new Promise(resolve => {
			import('../../../utils/test/tracking.json').then(({ default: content }) =>
				resolve(content)
			)
		})
	},
	/**
	 * Send marketing datas
	 * @param  {mail: 'email@test.com', accept: true/false}
	 */
	postMarketingInfos: beneficiaryData => {
		return Repository.post('/visitor', {
			email: beneficiaryData.mail,
			acceptMarketing: beneficiaryData.accept
		})
	},
	/**
	 * Send invitation to the mail listed
	 * @param  ['email@test.com']
	 */
	postInvitationList: mailList => {
		return Repository.post('/share', { recipients: mailList })
	}
}
